

export class Menudata {
  title: string = "Empty";
  items: string[]  = new Array();
}

export class WifiMenuData {
  menudata: Menudata[] = new Array();
}


